import { combineReducers } from "redux";

import cookie from "./cookies";

export default combineReducers({
  cookie
});
